@let id = 'otovo-iframe';
@let iFrameClass = 'class="absolute left-0 overflow-hidden border-0 px-4';
@let iFrameTitle = 'otovo-address-search';

<div class="relative min-h-[108px] w-full pt-sm">
  @if (lang === 'fr') {
    <ng-container [ngTemplateOutlet]="fr" />
  } @else if (lang === 'it') {
    <ng-container [ngTemplateOutlet]="it" />
  } @else {
    <ng-container [ngTemplateOutlet]="de" />
  }
</div>

<ng-template #fr>
  <iframe
    [attr.id]="id"
    frameborder="0"
    data-src="https://solar.otovo.com/fr-ch/search?context=iframe&utm_source=Buildigo&theme=default&utm_campaign=aktion"
    height="108px"
    loading="lazy"
    width="100%"
    data-qa="iframe"
    [title]="iFrameTitle"
    [class]="iFrameClass"
  ></iframe>
</ng-template>

<ng-template #it>
  <iframe
    [attr.id]="id"
    frameborder="0"
    data-src="https://solar.otovo.com/it-ch/search?context=iframe&utm_source=Buildigo&theme=default&utm_campaign=aktion"
    height="108px"
    loading="lazy"
    width="100%"
    data-qa="iframe"
    [title]="iFrameTitle"
    [class]="iFrameClass"
  ></iframe>
</ng-template>

<ng-template #de>
  <iframe
    [attr.id]="id"
    frameborder="0"
    data-src="https://solar.otovo.com/de-ch/search?context=iframe&utm_source=Buildigo&theme=default&utm_campaign=aktion"
    height="108px"
    loading="lazy"
    width="100%"
    data-qa="iframe"
    [title]="iFrameTitle"
    [class]="iFrameClass"
  ></iframe>
</ng-template>
